import {ECookies} from "@/types/cookies.enum";
import TagManager from "react-gtm-module";

const getCookie = (name: any): string | null => {
	const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
	return match ? decodeURIComponent(match[2]) : null;
};
export function initGoogleTagManager() {
	const consent = getCookie(ECookies.COOKIE_CONSENT_ANALYTICS);

	if (consent === "true") {
		TagManager.initialize({gtmId: "GTM-542G35DW"});
	}
}
